import { api } from "@api/api";
import { Store } from "@modules/stores/types";
import { StoreFormValues } from "@modules/stores/validations";

export async function editStoreService(id: string, data: Partial<StoreFormValues>): Promise<Store> {
  const { data: store } = await api.patch<Store>(`v1/store_admin/${id}/`, data);

  return store;
}
